(() => {
  if (window.TDHeaderReviewsReady) return;
  window.TDHeaderReviewsReady = true;
  let opener = null;
  let previousLock = false;
  let pointerStartedOutside = false;
  const dialog = () => document.querySelector('[data-td-header-reviews-dialog]');
  const restore = (element) => {
    const frame = element.querySelector('[data-td-header-reviews-frame]');
    if (frame) {
      frame.removeAttribute('srcdoc');
      frame.removeAttribute('src');
    }
    document.body.classList.remove('tdhr-open');
    if (!previousLock && !document.querySelector('dialog[open]')) document.body.classList.remove('overflow-hidden');
    if (opener?.isConnected) opener.focus({ preventScroll: true });
    opener = null;
  };
  const close = () => {
    const element = dialog();
    if (element?.open) element.close();
  };
  const open = (trigger) => {
    const element = dialog();
    if (!element || typeof element.showModal !== 'function') return false;
    if (element.open) return true;
    opener = trigger;
    previousLock = document.body.classList.contains('overflow-hidden');
    element.showModal();
    document.body.classList.add('tdhr-open', 'overflow-hidden');
    element.querySelector('[data-td-header-reviews-close]')?.focus({ preventScroll: true });
    const frame = element.querySelector('[data-td-header-reviews-frame]');
    const template = element.querySelector('[data-td-header-reviews-document]');
    if (frame && template) {
      // The Loox widget owns this document; no Shopify page is embedded.
      frame.srcdoc = '<!doctype html><html><head><meta charset="utf-8"></head><body>' + template.innerHTML + '</body></html>';
    }
    return true;
  };
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-td-header-reviews-open]');
    if (trigger && open(trigger)) {
      event.preventDefault();
      return;
    }
    if (event.target.closest('[data-td-header-reviews-close]')) close();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && dialog()?.open) {
      event.preventDefault();
      close();
    }
  });
  const bind = () => {
    const element = dialog();
    if (!element || element.dataset.reviewsReady === 'true') return;
    element.dataset.reviewsReady = 'true';
    element.addEventListener('close', () => restore(element));
    element.addEventListener('pointerdown', (event) => {
      pointerStartedOutside = event.target === element;
    });
    element.addEventListener('click', (event) => {
      if (event.target === element && pointerStartedOutside) close();
      pointerStartedOutside = false;
    });
  };
  bind();
  document.addEventListener('shopify:section:load', bind);
})();

